import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.min.css";
import Logo from '../../image/logo.gif';
import './Header.css';
import '../../style.css';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnchor, faHome, faMobile } from "@fortawesome/free-solid-svg-icons";
import { faReact, faServicestack, faStackExchange } from "@fortawesome/free-brands-svg-icons";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container className="header">
        <Navbar.Brand href="/">
          <img src={Logo} alt="" />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto mainNav" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link href="/#home"
               onClick={() => updateExpanded(false)}>
                <FontAwesomeIcon icon={faHome}/> Home
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/#service"
                onClick={() => updateExpanded(false)}
              >
                <FontAwesomeIcon icon={faServicestack}/> Services
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/#portfolio"
                onClick={() => updateExpanded(false)}
              >
                <FontAwesomeIcon icon={faReact}/> Portfolioes
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/#skill"    
                onClick={() => updateExpanded(false)}
              >
                <FontAwesomeIcon icon={faAnchor}/> Skills
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/#testiminial"
                onClick={() => updateExpanded(false)}
              >
                <FontAwesomeIcon icon={faStackExchange}/> Testimonial
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="/#contact"
                onClick={() => updateExpanded(false)}
              >
                <FontAwesomeIcon icon={faMobile}/> Contact
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
